export default __webpack_public_path__ + "static/media/AP2023_Wir-sind-dabei_Socials_1200x630px.a1d66d32.png";